<template>
  <v-dialog v-model="AddToLibraryDialog" persistent max-width="650px">
    <v-card>
      <v-toolbar dark color="secondary" max-height="64px">
        <v-card-title> Assign to Training Library </v-card-title>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <button
              type="button"
              class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm mr-2"
              v-bind="attrs"
              v-on="on"
              dark
            >
              <i class="fas fa-question" />
            </button>
          </template>
          <v-img
            lazy-src="https://place-hold.it/600x350?text=Image%20Loading"
            src="https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/curriculum_info.png"
            max-width="600"
            max-height="350"
          />
          <span>Assign to Training Library in your Home Page.</span>
        </v-tooltip>
        <button
          type="button"
          class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
          :disabled="isLoading"
          @click="AddToLibraryDialog = false"
        >
          <i class="fas fa-times" />
        </button>
      </v-toolbar>
      <v-container class="pa-10">
        <span v-if="unit && unit.series">
          Current: <br />
          <span class="text-warning">
            {{ unit.series.series.module.course.curriculum.name }} >
            {{ unit.series.series.module.course.name }} >
            {{ unit.series.series.module.name }} >
            {{ unit.series.series.name }}
          </span>
        </span>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <label>
              Assign to curriculum

              <v-tooltip top>
                <template #activator="{ on }">
                  <span
                    v-on="on"
                    class="text-small text-primary font-weight-light font-italic"
                  >
                    <i class="fas fa-info-circle" />
                    See info
                  </span>
                </template>
                <span>
                  <v-img
                    lazy-src="https://place-hold.it/600x350?text=Image%20Loading"
                    src="https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/curriculum_info.png"
                    max-width="600"
                    max-height="350"
                  />
                  <span>
                    Curriculums are <strong>set of courses</strong> available at
                    the home page.
                  </span>
                </span>
              </v-tooltip>
            </label>
            <v-autocomplete
              v-model="curriculum_id"
              name="curriculum_id"
              label="Click to select or add Curriculum"
              :disabled="isLoading"
              :loading="isLoading"
              :items="curriculums"
              :item-text="(item) => item.name"
              :item-value="(item) => item.id"
              @change="fetchCourse"
              append-icon=""
              :menu-props="{ closeOnClick: true }"
            >
              <template v-slot:selection="data">
                {{ data.item.name }} &nbsp;
                <span
                  :class="
                    data.item.is_draft
                      ? 'text-small'
                      : 'text-success text-small'
                  "
                  >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                >
              </template>
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ data.item.name }}
                    <span
                      :class="
                        data.item.is_draft
                          ? 'text-small'
                          : 'text-success text-small'
                      "
                      >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle
                    v-html="data.item.company_author.name"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleAddCurriculumDialog()">
                  <v-list-item-content>
                    <v-list-item-title
                      style="
                        font-size: 17px;
                        display: flex;
                        justify-content: center;
                        gap: 7px;
                        align-items: center;
                      "
                    >
                      <i class="fas fa-plus"></i>
                      <span>Create New Curriculum</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <label>
              Assign to course

              <v-tooltip top>
                <template #activator="{ on }">
                  <span
                    v-on="on"
                    class="text-small text-primary font-weight-light font-italic"
                  >
                    <i class="fas fa-info-circle" />
                    See info
                  </span>
                </template>
                <span>
                  <v-img
                    lazy-src="https://place-hold.it/600x350?text=Image%20Loading"
                    src="https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/course_info.png"
                    max-width="600"
                    max-height="350"
                  />
                  <span>
                    Courses are <strong>set of modules</strong> available at the
                    home page under a curriculum.
                  </span>
                </span>
              </v-tooltip>
            </label>
            <v-autocomplete
              v-model="category_id"
              name="category_id"
              :disabled="curriculum_id == null || isLoading"
              :loading="isLoading"
              :label="
                !curriculum_id
                  ? 'Disabled because no curriculum is selected'
                  : 'Click to select or add Course'
              "
              :items="courses"
              :item-text="(item) => item.name"
              :item-value="(item) => item.id"
              append-icon=""
              @change="fetchModules"
              :menu-props="{ closeOnClick: true }"
            >
              <template v-slot:selection="data">
                {{ data.item.name }} &nbsp;
                <span
                  :class="
                    data.item.is_draft
                      ? 'text-small'
                      : 'text-success text-small'
                  "
                  >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                >
              </template>
              <template v-slot:item="data">
                {{ data.item.name }} &nbsp;
                <span
                  :class="
                    data.item.is_draft
                      ? 'text-small'
                      : 'text-success text-small'
                  "
                  >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                >
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleAddCategoryDialog()">
                  <v-list-item-content>
                    <v-list-item-title
                      style="
                        font-size: 17px;
                        display: flex;
                        justify-content: center;
                        gap: 7px;
                        align-items: center;
                      "
                    >
                      <i class="fas fa-plus"></i>
                      <span>Create New Course</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <label>
              Assign to module

              <v-tooltip top>
                <template #activator="{ on }">
                  <span
                    v-on="on"
                    class="text-small text-primary font-weight-light font-italic"
                  >
                    <i class="fas fa-info-circle" />
                    See info
                  </span>
                </template>
                <span>
                  <v-img
                    lazy-src="https://place-hold.it/600x350?text=Image%20Loading"
                    src="https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/module_info.png"
                    max-width="600"
                    max-height="350"
                  />
                  <span>
                    Modules are <strong>set of series</strong> available in a
                    course page.
                  </span>
                </span>
              </v-tooltip>
            </label>
            <v-autocomplete
              v-model="module_id"
              :disabled="category_id == null || isLoading"
              :loading="isLoading"
              name="module_id"
              :label="
                !category_id
                  ? 'Disabled because no course is selected'
                  : 'Click to select or add Module'
              "
              :items="modules"
              append-icon=""
              @change="fetchSeries"
              :item-text="(item) => item.name"
              :item-value="(item) => item.id"
              :menu-props="{ closeOnClick: true }"
            >
              <template v-slot:selection="data">
                {{ data.item.name }} &nbsp;
                <span
                  :class="
                    data.item.is_draft
                      ? 'text-small'
                      : 'text-success text-small'
                  "
                  >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                >
              </template>
              <template v-slot:item="data">
                {{ data.item.name }} &nbsp;
                <span
                  :class="
                    data.item.is_draft
                      ? 'text-small'
                      : 'text-success text-small'
                  "
                  >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                >
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleAddModuleDialog()">
                  <v-list-item-content>
                    <v-list-item-title
                      style="
                        font-size: 17px;
                        display: flex;
                        justify-content: center;
                        gap: 7px;
                        align-items: center;
                      "
                    >
                      <i class="fas fa-plus"></i>
                      <span>Create New Module</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <label>
              Assign to series

              <v-tooltip top>
                <template #activator="{ on }">
                  <span
                    v-on="on"
                    class="text-small text-primary font-weight-light font-italic"
                  >
                    <i class="fas fa-info-circle" />
                    See info
                  </span>
                </template>
                <span>
                  <v-img
                    lazy-src="https://place-hold.it/600x350?text=Image%20Loading"
                    src="https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/series_info.png"
                    max-width="600"
                    max-height="350"
                  />
                  <span class="text-small font-weight-light font-italic">
                    Series are <strong>set of units</strong> available in a
                    module page.
                  </span>
                </span>
              </v-tooltip>
            </label>
            <v-autocomplete
              v-model="series_id"
              :disabled="module_id == null || isLoading"
              name="module_id"
              :label="
                !module_id
                  ? 'Disabled because no module is selected'
                  : 'Click to select or add Series'
              "
              :items="series"
              :item-text="(item) => item.name"
              :item-value="(item) => item.id"
              :menu-props="{ closeOnClick: true }"
              append-icon=""
              :loading="isLoading"
            >
              <template v-slot:selection="data">
                {{ data.item.name }} &nbsp;
                <span
                  :class="
                    data.item.is_draft
                      ? 'text-small'
                      : 'text-success text-small'
                  "
                  >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                >
              </template>
              <template v-slot:item="data">
                {{ data.item.name }} &nbsp;
                <span
                  :class="
                    data.item.is_draft
                      ? 'text-small'
                      : 'text-success text-small'
                  "
                  >({{ data.item.is_draft ? 'Draft' : 'Published' }})</span
                >
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleAddSeriesDialog()">
                  <v-list-item-content>
                    <v-list-item-title
                      style="
                        font-size: 17px;
                        display: flex;
                        justify-content: center;
                        gap: 7px;
                        align-items: center;
                      "
                    >
                      <i class="fas fa-plus"></i>
                      <span>Create New Series</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue-grey darken-1"
          text
          @click="close"
          :disabled="isLoading"
          :loading="isLoading"
          class="mr-3 px-6"
          >Cancel</v-btn
        >
        <v-btn
          color="success"
          class="px-6 mr-3"
          @click="publishLibrary"
          :disabled="isLoading"
          :loading="isLoading"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
    <add-category-dialog
      :current-curriculum="curriculum_id"
      :add-category-dialog="addCategoryDialog"
      :toggle-add-category-dialog="toggleAddCategoryDialog"
      v-on:course="selectedCourse"
      :closeModal="toggleClose"
      :key="key"
    ></add-category-dialog>
    <add-curriculum-dialog
      :add-curriculum-dialog="addCurriculumDialog"
      :self-assign="selfAssign"
      :toggle-add-curriculum-dialog="toggleAddCurriculumDialog"
      :closeModal="toggleClose"
      v-on:curriculum="selectedCurriculum"
    ></add-curriculum-dialog>
    <add-module-dialog
      :category="course"
      :add-module-dialog="addModuleDialog"
      :toggle-add-module-dialog="toggleAddModuleDialog"
      :closeModal="toggleClose"
      v-on:addedModule="selectedModule"
      :key="key"
    ></add-module-dialog>
    <add-series-dialog
      :module="module"
      :add-series-dialog="addSeriesDialog"
      :toggle-add-series-dialog="toggleAddSeriesDialog"
      :closeModal="toggleClose"
      v-on:series="selectedSeries"
      :key="key"
    ></add-series-dialog>
  </v-dialog>
</template>

<script>
import { find as _find } from 'lodash-es';
import EventBus from '@/plugins/eventBus';
import AddCategoryDialog from '@/components/course-certification/includes/AddCategoryDialog';
import AddCurriculumDialog from '@/components/course-certification/includes/AddCurriculumDialog';
import AddModuleDialog from '@/components/course-certification/includes/AddModuleDialog';
import AddSeriesDialog from '@/components/course-certification/includes/AddSeriesDialog';

export default {
  name: 'AddToLibrary',
  components: {
    AddCategoryDialog,
    AddCurriculumDialog,
    AddModuleDialog,
    AddSeriesDialog,
  },
  props: {
    unit: Object,
    value: Boolean,
    closeToggle: Function,
    selfAssign: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    curriculum_id: null,
    course_id: null,
    category_id: null,
    categories: [],
    module_id: null,
    series_id: null,
    modules: [],
    courses: [],
    series: [],
    tags: [],
    isLoading: false,
    addCurriculumDialog: false,
    addCategoryDialog: false,
    addModuleDialog: false,
    addSeriesDialog: false,
    course: null,
    module: null,
    key: 0,
  }),
  computed: {
    AddToLibraryDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    curriculums() {
      return this.$store.state.curriculums.curriculums;
    },
    curriculumsReady() {
      return this.$store.state.curriculums.isCurriculumsReady;
    },
  },
  created() {
    if (this.curriculums.length <= 0) {
      this.fetchCurriculums();
    }
  },
  methods: {
    //function for library
    publishLibrary() {
      this.isLoading = true;
      this.axios
        .post('lms-manager/units/save/assign', {
          unit_id: this.unit.id,
          module_id: this.module_id,
          series_id: this.series_id,
        })
        .then((response) => {
          this.item = response.data;
        })
        .catch((response) => {
          console.log(response);
        })
        .finally((response) => {
          this.$notify('success', 'Unit Saved!');
          this.$emit('fetch-units');
          this.$emit('save');
          EventBus.$emit('RELOAD_TABLE');
          EventBus.$emit('refreshCourseCertification');
          this.close();
        });
    },
    reset() {
      this.course_id = null;
      this.category_id = null;
      this.module_id = null;
      this.isLoading = false;
    },
    close() {
      this.reset();
      this.AddToLibraryDialog = false;
    },
    fetchCurriculums() {
      this.isLoading = true;
      this.$store
        .dispatch('courseCertification/getCurriculums')
        .then(({ data }) => {
          this.$store.commit('courseCertification/setListCurriculums', data);
          this.$nextTick(() => {
            this.reset();
          });
        });
    },
    fetchCourse() {
      this.isLoading = true;

      this.axios
        .get('/client/lms/fetchCurriculumCourses', {
          params: { curriculum_id: this.curriculum_id },
        })
        .then(({ data }) => {
          this.courses = data;
          this.$nextTick(() => {
            this.isLoading = false;
          });
        });
    },
    fetchModules() {
      this.isLoading = true;
      this.axios
        .get('/client/lms/fetchCourseModules', {
          params: {
            course_id: this.category_id,
          },
        })
        .then(({ data }) => {
          this.modules = data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log('something went wrong with fetching categories');
          this.isLoading = false;
        });
    },
    fetchSeries() {
      this.isLoading = true;
      this.axios
        .get('/client/lms/fetchSeries', {
          params: { module_id: this.module_id },
        })
        .then(({ data }) => {
          this.series = data;
          this.$nextTick(() => {
            this.isLoading = false;
          });
        });
    },
    toggleAddCurriculumDialog() {
      this.addCurriculumDialog = !this.addCurriculumDialog;
    },
    toggleAddCategoryDialog() {
      this.forceRerender();
      this.addCategoryDialog = !this.addCategoryDialog;
      this.addModuleDialog = false;
    },
    toggleAddModuleDialog() {
      this.forceRerender();
      this.addModuleDialog = !this.addModuleDialog;
      this.addCurriculumDialog = false;
      this.addCategoryDialog = false;
      this.addSeriesDialog = false;

      this.course = _find(this.courses, { id: this.category_id });
    },
    toggleAddSeriesDialog() {
      this.forceRerender();
      this.addSeriesDialog = !this.addSeriesDialog;
      this.addCurriculumDialog = false;
      this.addCategoryDialog = false;
      this.addModuleDialog = false;

      this.module = _find(this.modules, { id: this.module_id });
    },
    toggleClose() {
      this.addCategoryDialog = false;
      this.addCurriculumDialog = false;
      this.addModuleDialog = false;
      this.addSeriesDialog = false;
    },
    selectedCurriculum(data) {
      this.curriculums.unshift({
        name: data.name,
        id: data.id,
        company_author: {
          name: this.$auth.user().dealer.name,
        },
      });
      this.curriculum_id = data.id;
    },
    selectedCourse(data) {
      this.courses.unshift({
        id: data.id,
        name: data.name,
      });
      this.course = data;
      this.category_id = data.id;
    },
    selectedModule(data) {
      this.modules.unshift({
        id: data.id,
        name: data.name,
      });
      this.module = data;
      this.module_id = data.id;
    },
    selectedSeries(data) {
      this.series.unshift({
        id: data.id,
        name: data.name,
      });
      this.series_id = data.id;
    },
    forceRerender() {
      this.key += 1;
    },
  },
};
</script>
